export const CREATE_OFFICE_REQUEST = "CREATE_OFFICE_REQUEST";
export const CREATE_OFFICE_SUCCESS = "CREATE_OFFICE_SUCCESS";
export const CREATE_OFFICE_FAILURE = "CREATE_OFFICE_FAILURE";

export const GET_OFFICE_REQUEST = "GET_OFFICE_REQUEST";
export const GET_OFFICE_SUCCESS = "GET_OFFICE_SUCCESS";
export const GET_OFFICE_FAILURE = "GET_OFFICE_FAILURE";

